// extracted by mini-css-extract-plugin
module.exports = {"equilibriumChart":"EquilibriumGraph_equilibriumChart__By7z9","supplyGraph":"EquilibriumGraph_supplyGraph__Z7nzn"};